import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HttpLoadingOverlayComponent } from '@common/app/layout/http-loading-overlay/http-loading-overlay.component';
import { MessageToastHostComponent } from '@common/app/layout/message-toast-host/message-toast-host.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HttpLoadingOverlayComponent, MessageToastHostComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
